import { isArray } from "class-validator";

export function valueOrArrayToArrayOrUndefined<T>(value: T | Array<T> | undefined): Array<T> | undefined {
    if (!value) {
        return undefined;
    }

    if (isArray(value)) {
        return value as Array<T>;
    }

    return [value as T];
}
